/* Time Zone IANA name -> Display Name Filter
 *
 * Angular Module: "trackerbase-app.filters.format-time-zone-name"
 * Filter exposed as: tbFormatTZName
 */

import angular from "angular";

function formatTimeZoneNameFilter(ianaTimeZoneName) {

    if ((ianaTimeZoneName != null) &&
        (angular.isString(ianaTimeZoneName))) {

        var tzNameParts = ianaTimeZoneName.split("/");
        tzNameParts.shift();

        var tzDisplayName = tzNameParts.map(function(tzPart) {
            return tzPart.replace("_"," ");
        }).join(": ");

        return tzDisplayName;
    }
    else {
        return null;
    }
}

function formatTimeZoneNameFilterFactory() {
    return formatTimeZoneNameFilter;
}

export default angular
    .module("trackerbase-app.filters.format-tz-name-filter", [])
    .filter("tbFormatTZName", formatTimeZoneNameFilterFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/filters/FormatTimeZoneNameFilter.js
// module id = 4WMM
// module chunks = 1